requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!customElements.get('recently-viewed')) {
      class RecentlyViewed extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.slider = themeBase.isSlider(this);
          !this.slider ? this.init() : scriptController.executeWhenScriptLoaded('slider-component.js', () => this.init());
        }

        init() {
          this.recentlyViewedProducts = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

          const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(`/collections/all?view=recently-viewed&handles=${this.recentlyViewedProducts.join('+')}&products_to_show=${this.dataset.productsToShow}&sections=${this.dataset.sectionId}`)
              .then((response) => response.json())
              .then((text) => {
                const html = document.createElement('div');

                html.innerHTML = text[this.dataset.sectionId];

                const recentlyViewed = html.querySelector('recently-viewed');

                this.innerHTML = recentlyViewed.innerHTML;
                this.classList.add('recently-viewed--loaded');
                if (this.slider) {
                  this.slider.resetPages();
                }
                window.dispatchEvent(new CustomEvent('MutationObserverLoaded'));
                window.lazyImages.find();
              })
              .catch((e) => {
                console.error(e);
              });
          };

          new IntersectionObserver(handleIntersection.bind(this), {
            rootMargin: '1000px 0px 1000px 0px'
          }).observe(this);
        }
      }

      customElements.define('recently-viewed', RecentlyViewed);
    }
  });
});